import React, { useState, ChangeEvent, useEffect } from 'react';
import ErrorMessage from '../ErrorMessages/ErrorMessage';
import { useSelector } from 'react-redux';

interface PercentageInputProps {
  label: string;
  required?: boolean;
  initialValue?: string;
  onChange?: (value: string) => void;
  min?: number;
  max?: number;
  id?: string;
  name?: string;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  setText: (value: string) => void;
  errorMessage?: string;
  setTextError?: (value: string) => void;
}

const PercentageInput: React.FC<PercentageInputProps> = ({
  label,
  required = false,
  initialValue = '',
  onChange,
  setText,
  min = 1,
  max = 100,
  id,
  errorMessage,
  name,
  placeholder = 'Enter the percentage',
  className = '',
  disabled = false,
  setTextError,
}) => {
  const [value, setValue] = useState<string>(initialValue);
  const upfrontValue = useSelector((state: any) => state.upfrontPercentageSlice.value);

  useEffect(() => {
    setValue((upfrontValue || initialValue) + '%');
  }, []);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    let newValue = e.target.value.replace(/[^\d.]/g, '');

    // Handle multiple decimal points
    const decimalCount = (newValue.match(/\./g) || []).length;
    if (decimalCount > 1) {
      newValue = newValue.replace(/\.(?=.*\.)/g, '');
    }

    // Limit input to max 5 characters (including decimal point)

    // Ensure value is between 1 and 100
    const numValue = parseFloat(newValue);
    if (numValue > 100) {
      newValue = '100';
    }

    setValue(newValue ? `${newValue}%` : '');

    if (newValue !== ''){
      setTextError?.('');
    }
    setText(newValue);
    onChange?.(newValue);
  };

  return (
    <div className={`w-full mt-2 ${className}`}>
      <div className="flex items-center mb-2">
        <label htmlFor={id} className="text-gray-800 font-medium text-sm">
          {label}
        </label>
        {required && (
          <span className="text-[#FF0000] ml-1">*</span>
        )}
      </div>

      <input
        type="text"
        id={id}
        name={name}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={disabled}
        className={`w-[320px] my-1 focus:my-[3px] px-[15px] focus:px-[14px] py-4 font-[500] rounded-lg border ${errorMessage ? 'border-[#FF0000]' : 'border-P_light_active'
          } focus:outline-none focus:border-2 text-gray-700 placeholder-secondary_text`}
      />

      {
        errorMessage && (
          <ErrorMessage errorMessage={errorMessage} />
        )
      }
      <p className="mt-1 text-secondary_text text-sm w-[320px]">
        Note: Enter a percentage value between {min} and {max}
      </p>

    </div>
  );
};

export default PercentageInput;